<template>
  <div class="login container">
    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">

        <div class="d-flex justify-content-between">
          <div class="col-xs-6 pl-3 pt-5">
            <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
          </div>
          <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="product == 0 || price_modifier == 0 || (price_modifier == 'Custom' && custom_price_modifier_value == 0) || errors.has('custom_price') || errors.has('product') || (!physicalJourney && !digitalJourney)" margin="no-margin" :loading="submitted" />
          </div>
        </div>
        
        <div class="row">
          <h2 class="col-md-12 pt-2">Select a card</h2>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="select-holder size-limit d-flex justify-content-center p-2">
            <select v-model="product" v-if="products" @change="productChange">
              <option value="0">Select card</option>
              <option v-for="product in products" :value="product" v-bind:key="product.id">
                {{product.name}}
              </option>
            </select>
          </div>
      </div>
        

      <div class="row d-flex justify-content-center">
          <div v-if="product != 0" class="select-holder size-limit p-2 pb-4">
            <select v-model="price_modifier" name="price_modifier">
              <option v-if="product.PriceModifiers.length > 0" value="0">Select price</option>
              <option v-for="modify in orderedPrices" 
                  :value="modify.id" 
                  :key="modify.id" 
                  v-html="product.ProductType.id == 2 ? (modify.description ? modify.description +' - ' : '' )+getPriceModifierDisplayValue(modify,1) : getPriceModifierDisplayValue(modify,1)">
              </option>
              <option value="Custom" label="Custom" v-if="shouldShowCustomInput">Custom</option>
            </select>
          </div>
          <!-- Custom price only -->
          <div v-if="price_modifier === 'Custom' || shouldShowCustomInputOnly" class="text-input-holder size-limit p-2 pb-4">
            <currency-input
                  v-model="custom_price_modifier_value"
                  label="Please enter a custom amount"
                  name="custom_price"
                  :currency="currency"
                  v-validate="`required|min_value:${product.webshop_min_custom_value}|max_value:${product.webshop_max_custom_value}`"                  
            />
          </div>
          <!-- -->
        </div>
      

      
        <div class="row buttons" v-if="product != 0">
          <cta type="button" class="col-md-6 pr-1 pl-1 pt-4 text-center text-md-right transparent" :active="physicalJourney" size="small" text="Physical" @click="physicalCard" />
          <cta type="button" class="col-md-6 pl-1 pr-1 pt-4 text-center text-md-left transparent" :active="digitalJourney" size="small" text="Digital" @click="digitalCard" v-if="digitalFulfilment"/>
        </div>
    
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        product         : 0,
        submitted       : false,
        digitalJourney  : false,
        physicalJourney : false,
        price_modifier  : 0,
        custom_price_modifier_value: 0,
        isInputActive: false,
        currency : null
      };
  },
  created:function(){
     this.init();
     this.currency = this.accountCurrency;
  },
  computed: {

    products(){
      return this.$store.getters.getProducts.filter(function (e) {
          return e.ProductType.id ===  1 || e.ProductType.id === 2;
        });
    },

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

    digitalFulfilment() {
      for(var i = 0; i < this.product.FulfilmentMethods.length; i++) {
        if(this.product.FulfilmentMethods[i].name == "Email") {
          return true;
        }
      }
      return false;
    },

    orderedPrices() {
      let orderedPrices = this.product.PriceModifiers.map((modifier) => modifier).sort((a, b) => a.price - b.price);
      return orderedPrices;
    },

    shouldShowCustomInput() {
      return this.product.allow_custom_price_modifier;
    },

    shouldShowCustomInputOnly() {
      return (this.product.allow_custom_price_modifier && this.product.webshop_min_custom_value && this.product.webshop_max_custom_value) && this.product.PriceModifiers.length == 0;
    },

    accountCurrency(){
      return this.$store.getters.getAccountCurrency;
    }
  },
  watch:{
      /**
			 * If the basket item has been edited and changed from custom to fixed amount, reset custom settings
			 * @return void
			 */
			price_modifier(newValue) {
				if (newValue !== "Custom") {
					this.custom_price_modifier_value = 0;
				}
			},
  },
  mounted: function(){
   
  },
  methods:{

    init(){
      if(typeof this.orderPayload.product !== 'undefined') {
        this.product         = this.orderPayload.product;
        this.digitalJourney  = this.orderPayload.digitalJourney;
        this.physicalJourney = this.orderPayload.physicalJourney;
        if(this.orderPayload.customPriceModifier){
          this.price_modifier  = "Custom";
          this.custom_price_modifier_value = this.orderPayload.custom_price_modifier_value;
        }
        else if(this.orderPayload.price_modifier){
          this.price_modifier  = this.orderPayload.price_modifier.id;
        }
      }
    },

    productChange(){
      if(this.product.PriceModifiers.length == 0){
        this.price_modifier = "Custom";
      }
      else{
        this.price_modifier = 0;
      }
      
    },

    physicalCard() {
      this.digitalJourney = false;
      this.physicalJourney = true;
    },

    digitalCard() {
      this.physicalJourney = false;
      this.digitalJourney = true;
    },

    submit() {
      if(this.price_modifier != "Custom"){ // Check if Custom value
        let priceModifier = 0;

        for(var i = 0; i < this.product.PriceModifiers.length; i++){
          if (this.product.PriceModifiers[i].id == this.price_modifier)
            priceModifier = this.product.PriceModifiers[i];
        }

        delete this.orderPayload['custom_price_modifier_value'];

        Object.assign(this.orderPayload, {
          'product': this.product, 
          'digitalJourney': this.digitalJourney,
          'physicalJourney': this.physicalJourney,
          'price_modifier': priceModifier,
          'customPriceModifier': false,
        });
      }
      else{ // Custom value selected
        delete this.orderPayload['price_modifier'];

        Object.assign(this.orderPayload, { 
          'product': this.product, 
          'digitalJourney': this.digitalJourney,
          'physicalJourney': this.physicalJourney,
          'customPriceModifier': true,
          'custom_price_modifier_value': this.custom_price_modifier_value
        });
      }

      this.$store.commit("ORDER_PAYLOAD",this.orderPayload);

      if(this.digitalJourney) {
        this.$router.push({ name: 'digital-gift'});
      }

      if(this.physicalJourney) {
        this.$router.push({ name: 'payment'});
      }

    }
    
  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

</style>
